module.exports = __webpack_public_path__ + "static/img/katakura_01.4d22868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_01.jpg
// module id = 58FR
// module chunks = 0